import { post } from '../../request/base';

export const loginApi = ( url: string, data: object ) => post( url, data, {
    headers: {
        'Content-Type': 'application/x-www-form-urlencoded',
    },
} );